import React from 'react';
import { ImageCarousel } from '@/components/index';
import { useReportContext } from '@/context/ReportContext';
import { ReportSection } from '@/reports/index';
import { ImageMetas } from '@/reports/types/people';

export interface PossiblePhotosSectionProps {
  personName: string;
  images: ImageMetas;
}

export function PossiblePhotosSection({
  personName,
  images,
}: PossiblePhotosSectionProps) {
  const photoString = images.length === 1 ? 'photo' : 'photos';

  const { permalink } = useReportContext();

  return (
    <ReportSection
      title="Possible Photos"
      sectionDescription={`${images.length} possible ${photoString} found`}
      sectionId="possible-photos-section"
      hasContent={images.length > 0}
      personName={personName}
    >
      <ImageCarousel
        images={images}
        permalink={permalink}
        personName={personName}
      />
    </ReportSection>
  );
}
